import axiosClient from "api/axios_client.js";

// The logged-in user's settings — used by SettingsContext, the app header and the settings page.
const apiUserSettings = {
  getMySettings: () => axiosClient.get(`/user-settings/get-my-settings`),
  updateSettings: (id, payload) => axiosClient.put(`/user-settings/update/${id}`, payload),
};

export default apiUserSettings;
